import React from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { trackWidgetClick } from './utils'
import { Anchor } from 'components/Anchor'

import type { IVideoCard } from './typings'

const BaseWidget = React.forwardRef<
  HTMLDivElement,
  IVideoCard & { className?: string }
>(({ title, thumbnailUrl, className, url, trackerWidgetData }, ref) => (
  <Anchor href={url} className="last:mb-0 mb-2 block">
    <div
      className={clsx(
        'rounded border border-subdued p-3',
        'flex gap-3',
        'cursor-pointer',
        className
      )}
      ref={ref}
      onClick={() =>
        trackWidgetClick({
          ...trackerWidgetData,
          widgetValue: {
            ...trackerWidgetData.widgetValue,
            url,
          },
        })
      }
    >
      <div className="relative flex-grow-0 flex-shrink-0 w-[118px] h-[68px] rounded overflow-hidden">
        {!!thumbnailUrl && (
          <div className="relative">
            <img
              className="object-cover object-center w-[118px] h-[68px] brightness-[0.6]"
              alt="topic thumbnail"
              src={thumbnailUrl}
            />
            <Icon
              color="inverse"
              fontSize="lg"
              className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
            >
              play_arrow
            </Icon>
          </div>
        )}
        {!thumbnailUrl && (
          <div className="grid place-items-center w-[118px] h-[68px] bg-gray-60">
            <Icon color="inverse">play_arrow</Icon>
          </div>
        )}
      </div>
      <div>
        <Text className="mb-2 line-clamp-2" variant="body-sm">
          {title}
        </Text>
      </div>
    </div>
  </Anchor>
))
BaseWidget.displayName = 'VideoCard'

export default BaseWidget
